export default function submitReview() {
  const form = document.querySelector(".js_review_form");
  const bucketName = "ramble-reviews";
  const bucketRegion = "us-east-1";
  const identityPoolId = "us-east-1:31f057df-6782-4339-82cf-2cf648f08d7f";

  function initAWS() {
    AWS.config.update({
      region: bucketRegion,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: identityPoolId
      })
    });

    var s3 = new AWS.S3({
      apiVersion: "2006-03-01",
      params: {Bucket: bucketName}
    });
  }

  function sendData(email, orderId, code, productId, numStars, uploadPromise) {
    const XHR = new XMLHttpRequest();

    const FD = new FormData(form);
    const json = {
      "stars": numStars,
      "email": email,
      "order_id": orderId,
      "product_id": productId,
      "code": code,
      "uploaded_image": !!document.getElementById("image").files.length,
      "title": FD.get("title"),
      "body": FD.get("body")
    };

    // TODO(matt) set up and point to a ramblemaps subdomain
    XHR.open("POST",
      "https://6wwzegrxz6.execute-api.us-east-1.amazonaws.com/api/");
    XHR.setRequestHeader("content-type", "application/json");

    // Scroll to top smoothly, and show spinner.
    const banner = document.getElementById("js_free_shipping");
    banner.scrollIntoView({behavior: "smooth"});

    // Hides the form, and shows the spinner while we await response.
    showSpinner();

    uploadPromise.then(
      function (data) {
        XHR.send(JSON.stringify(json));
      },
      function (err) {
        // Upload the form and drop the image when there is a failure here.
        // The image failing should not prevent the rest of the review from
        // being submit.
        XHR.send(JSON.stringify(json));
      }
    );

    XHR.addEventListener("load", (event) => {
      showThankYou(code);
    });
  }

  function showThankYou(code) {
    // After submitting the form, we hide the form and display the thank-you
    // text with the discount. Also includes a button to keep shopping.
    const afterSubmit = document.querySelector(".js_after_submit");
    const discount = document.querySelector(".js_discount");
    discount.innerHTML = code;

    hideSpinner();
    afterSubmit.style.display = "block";

    window.gtag("event", "submit", {
      event_category: "submitReview",
    });
  };

  function showSpinner() {
    form.style.display = "none";
    document.querySelector(".lds-roller").style.display = "block";
  }

  function hideSpinner() {
    document.querySelector(".lds-roller").style.display = "none";
  }

  function fillStars(numStars, stars) {
    stars.forEach((elem, index) => {
      if (numStars > index) {
        elem.classList.add("filled");
      } else {
        elem.classList.remove("filled");
      }
    });
  }

  function getNumStars(event, stars) {
    const selectedStar = event.target.closest(".icon-star");
    return Array.prototype.indexOf.call(stars, selectedStar) + 1;
  }

  function updateNumStars(event, stars) {
    const numStars = getNumStars(event, stars);
    fillStars(numStars, stars);

    return numStars;
  }

  function uploadImage(event, orderId, productId) {
    const files = event.target.files;
    if (!files.length) {
      return;
    }
    const file = files[0];
    const splitFileName = file.name.split('.');
    const ext = splitFileName[splitFileName.length - 1];
    const fileName = orderId + "-" + productId + "." + ext;

    const upload = new AWS.S3.ManagedUpload({
      params: {
        Bucket: bucketName,
        Key: fileName,
        Body: file
      }
    });

    window.gtag("event", "submit", {
      event_category: "uploadImage",
    });

    return upload.promise();
  }

  // if we are on reviews page
  if (form) {
    const stars = form.querySelectorAll(".icon-star");

    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get('order_id');
    const email = urlParams.get('email');
    const code = urlParams.get('code');
    // URL has form: ramblemaps.com/submit-review/PRODUCT_ID?xyz
    const productId = window.location.pathname.split('/')[2];
    const imageUpload = document.getElementById("image");
    let numStars = parseInt(urlParams.get('stars'), 10);
    // If the user never attempts to upload an image, we don't want to wait on
    // this promise. Once the user starts an upload, this promise will get
    // overwritten and will represent the state of the upload.
    let uploadPromise = Promise.resolve(true);

    fillStars(numStars, stars);
    initAWS();

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      sendData(email, orderId, code, productId, numStars, uploadPromise);
    });

    imageUpload.addEventListener("change", (event) => {
      uploadPromise = uploadImage(event, orderId, productId);
    });


    stars.forEach(elem => elem.addEventListener("click", (event) => {
      numStars = updateNumStars(event, stars);
    }));

    stars.forEach(elem => elem.addEventListener("mouseover", (event) => {
      const hoveredNumStars = getNumStars(event, stars);
      fillStars(hoveredNumStars, stars);
    }));

    stars.forEach(elem => elem.addEventListener("mouseout", (event) => {
      // Refill whatever number of stars were last clicked.
      fillStars(numStars, stars);
    }));
  }
}
